import styled from 'styled-components';

import { Link } from '@treams/treams-routes';

import { INavigationLink } from 'packages/kakapo-ui-kit/types/Navigation';
import Breakpoint from 'packages/kakapo-ui-kit/helpers/Breakpoint';

interface IProps extends INavigationLink {
	size?: SubheaderNavigationLinkSize;
}

export enum SubheaderNavigationLinkSize {
	Medium,
	Large,
}

interface IElementProps {
	isActive?: boolean;
	size?: SubheaderNavigationLinkSize;
}

const Wrapper = styled.span<IElementProps>`
	a {
		color: ${(props) => props.theme.colors.slateBlue};
		font-size: 15px;
		padding: 18px 0 17px 0;

		${(props) =>
			props.size === SubheaderNavigationLinkSize.Large
				? `
					@media screen and (min-width: ${Breakpoint.Medium}) {
						padding: 36px 0 35px 0;
					}
				`
				: `
		`}

		margin-right: 36px;
		display: inline-block;
		text-align: center;
		text-decoration: none;
		transition: 70ms color ease-out;

		&:hover {
			color: ${(props) => props.theme.colors.primary};
		}

		${(props) =>
			props.isActive
				? `
		color: ${props.theme.colors.primary};
		border-bottom: 1px solid ${props.theme.colors.primary};
	`
				: ''}
	}
`;

export default function SubheaderNavigationLink({
	title,
	to,
	isActive,
	size = SubheaderNavigationLinkSize.Medium,
}: IProps) {
	return (
		<Wrapper isActive={isActive} size={size}>
			<Link to={to}>{title}</Link>
		</Wrapper>
	);
}
